import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ScheduleMiddleware } from "../../../../../Store/Middlewares/ScheduleMiddleware";
import {
  InputField,
  Modal,
  TextComponent,
  TimeInput,
} from "../../../../../components";
import { FiClock } from "react-icons/fi";
import { IoWarningOutline } from "react-icons/io5";
import { PiSealCheck } from "react-icons/pi";
import addClock from "../.../../../../../../assets/images/addClock.png";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import styles from "./Schedule.module.css";
import DateInput from "../../../../../components/DateInput/DateInput";

const GroupEditSchedule = ({
  scheduleModal,
  setScheduleModal,
  details,
  scheduleData,
}) => {
  const dispatch = useDispatch();
  const [scheduleDeniedModal, setScheduleDeniedModal] = useState(false);
  const [scheduleSuccessModal, setScheduleSuccessModal] = useState(false);
  const [frequency, setFrequency] = useState(
    scheduleData?.frequency || "one_time",
  );
  const [title, setTitle] = useState(scheduleData?.name || "");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (scheduleData) {
      setFrequency(scheduleData?.frequency || "one_time");
      setTitle(scheduleData?.name || "");
      setStartDate(
        scheduleData?.start_date
          ? moment(scheduleData?.start_date, "YYYY-MM-DD").toDate()
          : "",
      );
      setEndDate(
        scheduleData?.end_date
          ? moment(scheduleData?.end_date, "YYYY-MM-DD").toDate()
          : "",
      );
    }
    if (!scheduleData) {
      setFrequency("");
      setTitle("");
      setEndTime(null);
      setStartTime(null);
      setStartDate(null);
      setEndDate(null);
    }
  }, [scheduleModal, scheduleData]);

  const onUpdateSchedule = () => {
    let userData = {
      groupID: details?.id,
      scheduleId: scheduleData?.id,
      title,
      frequency,

      startTime: startTime
        ? moment(startTime).format("HH:mm")
        : scheduleData?.raw_start_time,
      endTime: endTime
        ? moment(endTime).format("HH:mm")
        : scheduleData?.raw_end_time,
      startDate: startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : scheduleData?.raw_start_date,
      endDate: endDate
        ? moment(endDate).format("YYYY-MM-DD")
        : scheduleData?.raw_end_date,
    };
    if (
      !title ||
      // !frequency ||
      !startTime ||
      !endTime ||
      !startDate ||
      !endDate
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        }),
      );
    } else if (moment(startTime).isAfter(moment(endTime))) {
      dispatch(
        showAlert({
          type: "Error",
          message: "End time should be greater than Start time!",
        }),
      );
    } else {
      dispatch(ScheduleMiddleware.createUpdateGroupSchedule(userData))
        .then(() => {
          setScheduleModal(false);
          setScheduleSuccessModal(true);
          setEndTime(null);
          setStartTime(null);
          setTitle("");
          setStartDate(null);
          setEndDate(null);
          // setFrequency()
          // afterDispatch(false)
        })
        .catch(() => {
          setScheduleModal(false);
          setScheduleDeniedModal(true);
        });
    }
  };
  return (
    <>
      {/* /////////////////////////Schedule Modal///////////////////////// */}

      <Modal
        open={scheduleModal}
        onCancel={() => setScheduleModal(false)}
        icon={
          <img
            src={addClock}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Scheduling"}
        width={"800px"}
        twoButton
        okBtnTitle={"Update"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setScheduleModal(false);
          setScheduleDeniedModal(true);
        }}
        onClickOkButton={onUpdateSchedule}
        btnStyle={{ width: "80%" }}
        // headingClass={styles.modalHeading}
      >
        <div className={styles.schedule_modalMain}>
          <InputField
            value={title}
            placeholder={"Title"}
            onChange={(e) => setTitle(e.target.value)}
            label={"Title"}
          />
          <div className={styles.schedule_inputBox}>
            <div className={styles.schedule_input}>
              <DateInput
                label={"Start Date"}
                // value={startTime}
                value={startDate ? moment(startDate) : null}
                onChange={(e) => setStartDate(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
            <div className={styles.schedule_input}>
              <DateInput
                label={"End Date"}
                value={endDate ? moment(endDate) : null}
                onChange={(e) => setEndDate(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
          </div>
          <div className={styles.schedule_inputBox}>
            <div className={styles.schedule_input}>
              <TimeInput
                value={startTime ? moment(startTime) : null}
                label={"Start time"}
                placeholder={
                  scheduleData?.start_time
                    ? scheduleData?.start_time
                    : startTime
                      ? moment(startTime).format("HH:mm")
                      : "Select time"
                }
                onChange={(e) => setStartTime(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
            <div className={styles.schedule_input}>
              <TimeInput
                label={"End time"}
                value={endTime ? moment(endTime) : null}
                placeholder={
                  scheduleData?.end_time
                    ? scheduleData?.end_time
                    : endTime
                      ? moment(endTime).format("HH:mm")
                      : "Select time"
                }
                onChange={(e) => setEndTime(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
          </div>
          {/* <TextComponent
            text={"Set frequency"}
            style={{
              fontFamily: "Urbanist-semibold",
              fontSize: "var(--mobile-heading)",
            }}
          />
          <div className={styles.schedule_inputBox}>
            <TextComponent
              text={"One time"}
              className={
                frequency == "one_time"
                  ? styles.schedule_frequencyBtn
                  : styles.schedule_frequencyUnactiveBtn
              }
              onClick={() => setFrequency("one_time")}
            />
            <TextComponent
              text={"Until I turn it off "}
              className={
                frequency == "one_time"
                  ? styles.schedule_frequencyUnactiveBtn
                  : styles.schedule_frequencyBtn
              }
              onClick={() => setFrequency("until_turn_off")}
            />
          </div> */}
        </div>
      </Modal>

      {/* /////////////////////////schedule Successfully///////////////////////// */}

      <Modal
        open={scheduleSuccessModal}
        onCancel={() => setScheduleSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Scheduled Edited Successfully"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => {
          setScheduleSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      >
        {/* <TextComponent
          text={"10:00 AM to 11:00 AM"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        /> */}
      </Modal>

      {/* /////////////////////////Unable to schedule///////////////////////// */}

      <Modal
        open={scheduleDeniedModal}
        onCancel={() => setScheduleDeniedModal(false)}
        icon={
          <IoWarningOutline
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Unable to Schedule"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setScheduleDeniedModal(false)}
      >
        <TextComponent
          text={"immobilizer is already schedule on this time"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        />
      </Modal>
    </>
  );
};

export default GroupEditSchedule;
